import styled from 'styled-components';
import { Deactivation2 } from '@elfsight/widget-deactivation';
import {
  Button,
  createCustomCSSPrefixClassName,
  EmbedRoot,
  FloatingButton
} from '@elfsight/widget-ui';
import { getInvertedColor } from '@elfsight/widget-utils';
import { useSettings } from '@wu/widget-core';
import { meta } from '../../meta';

type TriggerButtonProps = {
  onClick: () => void;
  floating?: boolean;
};

export function TriggerButton({ onClick, floating }: TriggerButtonProps) {
  const settings = useSettings();
  const customCSSPrefixClassName = createCustomCSSPrefixClassName(
    meta.appAlias,
    settings.widgetId
  );

  const iconOnly = settings.triggerButtonType === 'icon';
  const textOnly = settings.triggerButtonType === 'text';

  const commonProps = {
    'aria-label': 'Open Appointment Booking Popup',
    color: settings.accentColor,
    fontColor: getInvertedColor(settings.accentColor),
    font: { fontSize: iconOnly ? 20 : 16, fontWeight: 700 },
    iconLeft: textOnly ? undefined : settings.triggerButtonIcon,
    iconOnly: iconOnly,
    children: iconOnly ? undefined : settings.triggerButtonText,
    borderRadius: iconOnly ? 32 : settings.triggerButtonRadius,
    height: iconOnly ? 52 : 44,
    fontFamily: settings.font,
    onClick: settings.displayDeactivation ? undefined : onClick,
    style: {
      boxShadow: settings.renderThumbnailMode
        ? '0px 0px 6px rgba(0, 0, 0, 0.1)'
        : undefined
    }
  };

  if (floating) {
    return (
      <Deactivation2 {...meta} {...settings}>
        <FloatingButton
          position={settings.triggerButtonPosition}
          withShadow={!settings.renderThumbnailMode}
          {...commonProps}
        >
          {settings.triggerButtonText}
        </FloatingButton>
      </Deactivation2>
    );
  }

  return (
    <CenteredEmbedRoot
      customCSSClassName={customCSSPrefixClassName}
      width="auto"
    >
      <Deactivation2 {...meta} {...settings}>
        <Button {...commonProps}>{settings.triggerButtonText}</Button>
      </Deactivation2>
    </CenteredEmbedRoot>
  );
}

const CenteredEmbedRoot = styled(EmbedRoot)`
  && {
    display: flex;
    justify-content: center;
  }
`;
